/* Utilismo · estilo Kalles — pacote de animações (liga/desliga na seção "KL · Animações") */
(function () {
  'use strict';
  var d = document;
  var html = d.documentElement;
  var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  var temIO = 'IntersectionObserver' in window;

  function tem(c) { return html.classList.contains(c); }
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }

  if (reduz) return;
  html.classList.add('kla-js');

  /* ---------- 1. Slides: marca o slide que está na tela ---------- */
  function slides(root) {
    if (!tem('kla--slides') && !tem('kla--parallax')) return;
    $$('.kl-slides', root).forEach(function (s) {
      if (s._kla) return;
      s._kla = 1;
      var t = s.querySelector('[data-pl-track]');
      if (!t) return;
      var itens = $$('.kl-slides__item', t);
      if (!itens.length) return;
      if (!temIO) {
        itens.forEach(function (i) { i.classList.add('is-atual'); });
      } else {
        itens[0].classList.add('is-atual');
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (x) { x.target.classList.toggle('is-atual', x.intersectionRatio >= 0.6); });
        }, { root: t, threshold: [0, 0.6, 1] });
        itens.forEach(function (i) { io.observe(i); });
      }

      if (tem('kla--parallax') && window.matchMedia('(hover: hover)').matches) {
        var pend = false;
        var ev = null;
        s.addEventListener('mousemove', function (e) {
          ev = e;
          if (pend) return;
          pend = true;
          window.requestAnimationFrame(function () {
            pend = false;
            var r = s.getBoundingClientRect();
            s.style.setProperty('--kla-mx', ((ev.clientX - r.left) / r.width - 0.5).toFixed(3));
            s.style.setProperty('--kla-my', ((ev.clientY - r.top) / r.height - 0.5).toFixed(3));
          });
        });
        s.addEventListener('mouseleave', function () {
          s.style.setProperty('--kla-mx', '0');
          s.style.setProperty('--kla-my', '0');
        });
      }
    });
  }

  /* ---------- 4. Produtos das coleções aparecem em sequência ---------- */
  var SEL_GRADE = [
    'main .product-grid > .grid__item',
    'main .collection-list > .collection-list__item',
    'main .blog-articles > *',
    'main .multicolumn-list > li',
    'main .complementary-slide'
  ].join(',');
  var ioGrade = null;
  function noTopo(e) {
    var b = e.getBoundingClientRect();
    return b.top < window.innerHeight * 0.96;
  }
  function grades(root) {
    if (!tem('kla--grades') || editor) return;
    var novos = $$(SEL_GRADE, root).filter(function (e) {
      return !e._kla && !e.closest('.kl') && !e.closest('.quick-add-modal');
    });
    if (!novos.length) return;
    var porPai = new Map();
    novos.forEach(function (e) {
      e._kla = 1;
      if (noTopo(e) || !temIO) return;
      var p = e.parentNode;
      var n = porPai.get(p) || 0;
      porPai.set(p, n + 1);
      e.style.setProperty('--kla-d', (n % 4) * 90 + 'ms');
      e.classList.add('kla-rv');
      if (!ioGrade) {
        ioGrade = new IntersectionObserver(function (en) {
          en.forEach(function (x) {
            if (x.isIntersecting) { x.target.classList.add('is-in'); ioGrade.unobserve(x.target); }
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
      }
      ioGrade.observe(e);
    });
  }
  /* Rede de segurança: revela o que já está na tela */
  function varrer() {
    $$('.kla-rv:not(.is-in)').forEach(function (e) {
      var b = e.getBoundingClientRect();
      if (b.width > 0 && b.top < window.innerHeight && b.bottom > 0) e.classList.add('is-in');
    });
  }

  /* ---------- 5. Fotos aparecem suavemente ao carregar ---------- */
  var FORA_IMG = '.kl-card, .kl-ban, .kl-cols, .kl-insta, .kl-slides, .kl-of, .kl-news, .uh';
  function imagens(root) {
    if (!tem('kla--imagens')) return;
    $$('main img[loading="lazy"]', root).forEach(function (img) {
      if (img._kla) return;
      img._kla = 1;
      if (img.complete || img.closest(FORA_IMG)) return;
      img.classList.add('kla-img', 'kla-img--espera');
      function pronto() { img.classList.remove('kla-img--espera'); }
      img.addEventListener('load', pronto, { once: true });
      img.addEventListener('error', pronto, { once: true });
      setTimeout(pronto, 8000);
    });
  }

  /* ---------- 8. Carrinho pula ao adicionar ---------- */
  function pular(el) {
    if (!el) return;
    el.classList.remove('kla-pula');
    void el.offsetWidth;
    el.classList.add('kla-pula');
    setTimeout(function () { el.classList.remove('kla-pula'); }, 900);
  }
  function carrinho() {
    if (!tem('kla--carrinho') || !('MutationObserver' in window)) return;
    var ic = d.getElementById('cart-icon-bubble');
    if (!ic || ic._kla) return;
    ic._kla = 1;
    var espera = null;
    new MutationObserver(function () {
      clearTimeout(espera);
      espera = setTimeout(function () {
        pular(d.getElementById('cart-icon-bubble'));
        $$('[data-pl-abrir="carrinho"]').forEach(pular);
      }, 60);
    }).observe(ic, { childList: true, subtree: true, characterData: true });
  }

  function init(root) {
    try { slides(root); } catch (e) {}
    try { grades(root); } catch (e) {}
    try { imagens(root); } catch (e) {}
  }

  init(d);
  try { carrinho(); } catch (e) {}

  /* Conteúdo que chega depois (filtros da coleção, recomendações, editor) */
  if ('MutationObserver' in window) {
    var main = d.querySelector('main');
    var pendente = null;
    if (main) {
      new MutationObserver(function () {
        clearTimeout(pendente);
        pendente = setTimeout(function () { init(main); }, 120);
      }).observe(main, { childList: true, subtree: true });
    }
  }
  var vp = false;
  window.addEventListener('scroll', function () {
    if (vp) return;
    vp = true;
    setTimeout(function () { vp = false; varrer(); }, 200);
  }, { passive: true });
  window.addEventListener('load', function () { setTimeout(varrer, 1500); });
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
